import {Injectable} from '@angular/core';
import {Prefix} from '../models/prefix.model';
import {Group} from '../models/group.model';
import {Http} from '@angular/http';
import {ApiConnectService} from './api-connect.service';
import {HttpClient} from '@angular/common/http';
import {StandardTypesService} from './standard-types.service';

@Injectable()
export class PrefixService {
  selectedPrefix: Prefix;
  selectedGroup: Group;
  found = false;
  groupPrefixes: Prefix[] = [];

  customStndNumber: string;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private standardTypesService: StandardTypesService) {
  }

  updateTypesList(typeList) {
    this.standardTypesService.setTypesList(typeList);
  }

  // Получить порядковый номер создаваемого стандарта за день:
  getCountStandardNumber(prefixID) {
    return this.http.get(this.apiURL.getCountStandardNum + prefixID, {observe: 'response'});
  }

  setGroupPrefixex(prefixes) {
    this.groupPrefixes = prefixes;
  }

  getGroupPrefixex() {
    return this.groupPrefixes;
  }

  getPrefixesForSelectedGroup() {
    return this.getPrefixesForGroup(this.selectedGroup.id);
  }

  getPrefixesForGroup(groupID) {
    return this.http.get(this.apiURL.getPrefixesForGroup + groupID, {observe: 'response'});
  }

  addNewPrefixToGroup(newPrefixName, groups) {
    const groupsIDs: any = [];
    for (const g of groups) {
      groupsIDs.push({id: g.id});
    }

    const data = {
      name: newPrefixName,
      prefixGroups: groupsIDs
    };
    return this.http.post(this.apiURL.createPrefixForGroups, data, {observe: 'response'});
  }

  isGroupNoSelectNow(newPrefix) {
    this.found = true;
    for (const grp of newPrefix.prefixGroups) {
      if (this.selectedGroup.id === grp.id) {
        this.found = false;
        break;
      }
    }
    return this.found;
  }

  editPrefixInGroup(newPrefix) {
    const prefixIndex = this.groupPrefixes.findIndex(item => item.id === newPrefix.id);

    if (!this.isGroupNoSelectNow(newPrefix)) {
      this.groupPrefixes[prefixIndex] = newPrefix;
    } else {
      if (prefixIndex !== -1) {
        this.groupPrefixes.splice(prefixIndex, 1);
      }
    }

    const groupsIDs = [];
    for (const grp of newPrefix.prefixGroups) {
      groupsIDs.push({id: grp.id});
    }

    const data = {
      id: newPrefix.id,
      name: newPrefix.name,
      prefixGroups: groupsIDs
    };
    return this.http.put(this.apiURL.editPrefixForGroups, data, {observe: 'response'});
  }

  editPrefixInGroupPre(newPrefix) {
    const groupsIDs = [];
    for (const grp of newPrefix.prefixGroups) {
      groupsIDs.push({id: grp.id});
    }
    const data = {
      id: newPrefix.id,
      name: newPrefix.name,
      prefixGroups: groupsIDs
    };
    return this.http.put(this.apiURL.editPrefixForGroups, data, {observe: 'response'});
  }

  getSelectedPrefix() {
    return this.selectedPrefix;
  }

  setSelectedPrefix(prfx) {
    this.selectedPrefix = prfx;
  }

  setActiveInitiatorGroup(group) {
    this.selectedGroup = group;
  }

  getSelectedGroup() {
    return this.selectedGroup;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/frefix.service.ts